<template>
  <div class="content">
    <el-tabs class="tabLv3 testContent" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>试题管理
        </span>
        <normalNav :parent="self">
          <button class="OrangeSmBtn" style="background: #6f67b9" @click="$refs.decideDialog.toAddNew()">
            新增判断题
          </button>
          <button class="GreenSmBtn" @click="$refs.selectDialog.toAddNew()">
            新增选择题
          </button>
        </normalNav>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/examQuestion/page" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="first">
              <el-table-column label="试题类型" prop="answerType" :formatter="answerSymbol" width="120"></el-table-column>
            </template>
            <template slot="first">
              <el-table-column label="试题内容" prop="question" show-overflow-tooltip></el-table-column>
            </template>
            <template slot="first">
              <el-table-column label="试题类别" prop="type" :formatter="typeSymbol"></el-table-column>
            </template>
            <template slot="first">
              <el-table-column label="正确答案" prop="answer" :formatter="decideAnswer"></el-table-column>
            </template>
            <template slot="first">
              <el-table-column label="创建时间" prop="createTime"></el-table-column>
            </template>
            <template slot="last">
              <el-table-column label="操作" width="200" align="left">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="toEdit(scope.$index, scope.row)">修改</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <select-dialog ref="selectDialog" :typeArr="typeArr"></select-dialog>
    <decide-dialog ref="decideDialog" :typeArr="typeArr"></decide-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from 'utils'
export default {
  data() {
    return {
      tabName: 'jsgl',
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {},
      //分页
      message: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      //设备列表数据
      typeArr: [],
      items: [
        {
          type: 'input',
          prop: 'question',
          label: '试题内容'
        },
        {
          type: 'select',
          prop: 'answerType',
          label: '试题类型',
          option: {
            option: [
              {
                label: '单选',
                value: 1
              },
              {
                label: '多选',
                value: 2
              },
              {
                label: '判断',
                value: 3
              }
            ]
          }
        },
        {
          type: 'select',
          prop: 'type',
          label: '试题类别',
          option: {
            option: []
          }
        }
      ]
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return []
    },
    dt() {
      return dt.map(({ label }) => label)
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    selectDialog: () => import('./selectDialog'),
    easyTable: () => import('public/easyTable'),
    decideDialog: () => import('./decideDialog')
  },
  methods: {
    getTypeArr() {
      this.$axiosget('operation/question/type/list').then((res) => {
        let data = res.data.data
        if (data.length > 0) {
          this.typeArr = data.map((item) => {
            return {
              label: item.name,
              value: item.id
            }
          })
          this.items[2].option.option = this.typeArr
        } else {
          this.typeArr = []
          this.items[1].option.option = this.typeArr
        }
      })
    },
    answerSymbol(row, column) {
      return row.answerType == 1
        ? '单选'
        : row.answerType == 2
        ? '多选'
        : '判断'
    },
    decideAnswer(row, column) {
      return row.answer == 'N'
        ? '错误'
        : row.answer === 'Y'
        ? '正确'
        : row.answer
    },
    typeSymbol(row, column) {
      return this.getTypeName(row.type)
    },
    toEdit(index, row) {
      if (row.answerType == 3) {
        this.$refs.decideDialog.toEdit(row)
      } else {
        this.$refs.selectDialog.toEdit(row)
      }
    },
    getTypeName(id) {
      let results = this.typeArr.find((item) => item.value == id)
      return results ? results.label : ''
    },
    reset_jsgl(fn) {
      fn()
      this.form_jsgl = {}
    },
    search_jsgl(fn) {
      fn()
    },
    addnewSelect() {},
    addnewDecide() {},
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axiosdelete('operation/examQuestion', {
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.status == '10000') {
              this.$refs.table_jsgl.getData()
              this.$message.success('删除成功!')
            }
          })
        })
        .catch(() => {})
    }
  },
  mounted() {
    this.getTypeArr()
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exam/testQuestion/index.vue